export class DialogSendSmsData {
    /**
     * Constructeur.
     * @param folderViewId : Id de la vue à laquelle appartient le dossier.
     * @param folderId : Id du dossier.
     */
    public constructor(
        public folderViewId: number,
        public folderId: string
    ) {}
}
